import { useState } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getInboxChannelsTableUrl } from '../../urls/inboxSettingsUrls';
import { getInboxId, getPageName } from '../../messenger-connections/operators/getters';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReconnectFBMPageBanner = ({
  messengerConnection
}) => {
  const inboxId = getInboxId(messengerConnection);
  const [bannerIsDissmissed, setBannerIsDissmissed] = useState(false);
  if (bannerIsDissmissed) return null;
  return /*#__PURE__*/_jsxs(Alert, {
    type: "danger",
    closeable: true,
    onClose: () => setBannerIsDissmissed(true),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "MessagesApp.ReconnectFBMPageBanner.title",
      options: {
        messengerPageName: getPageName(messengerConnection)
      }
    }),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "MessagesApp.ReconnectFBMPageBanner.description"
    }), /*#__PURE__*/_jsx(Button, {
      href: getInboxChannelsTableUrl({
        inboxId
      }),
      use: "tertiary",
      size: "extra-small",
      marginInlineStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "MessagesApp.ReconnectFBMPageBanner.reconnectButton"
      })
    })]
  });
};
ReconnectFBMPageBanner.displayName = 'ReconnectFBMPageBanner';
export default ReconnectFBMPageBanner;